import { render, staticRenderFns } from "./MainItem.vue?vue&type=template&id=55a6eede&scoped=true"
import script from "./MainItem.vue?vue&type=script&lang=js"
export * from "./MainItem.vue?vue&type=script&lang=js"
import style0 from "./MainItem.vue?vue&type=style&index=0&id=55a6eede&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a6eede",
  null
  
)

export default component.exports